import { render, staticRenderFns } from "./CardMovie.vue?vue&type=template&id=5e870ed1&"
import script from "./CardMovie.vue?vue&type=script&lang=js&"
export * from "./CardMovie.vue?vue&type=script&lang=js&"
import style0 from "./CardMovie.vue?vue&type=style&index=0&id=5e870ed1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports